import consumer from "./consumer"
import NotificationController from "../controllers/notification_controller"

consumer.subscriptions.create("ScraperNotificationChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
    console.log("Connected to ScraperNotificationChannel");
  },

  disconnected() {
    console.log("Disconnected from ScraperNotificationChannel")
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    console.log("Received notification data:", data);
    // Called when there's incoming data on the websocket for this channel
    // Use the static method from the notification controller
    NotificationController.show(data.message, data.type || 'info');
  }
});
